"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synced_createId = exports.reset = exports.get = void 0;
var namespace = 'synced-id';
var _obj = null;
var get = function () {
    if (!_obj) {
        var seed = 100;
        _obj = {
            synced_idCounter: seed,
        };
        reset(seed);
    }
    return _obj;
};
exports.get = get;
function reset(masterSeed) {
    if (masterSeed === void 0) { masterSeed = 0; }
    var obj = exports.get();
    if (!masterSeed) {
        masterSeed = obj.synced_idCounter + 1;
    }
    obj.synced_idCounter = masterSeed;
}
exports.reset = reset;
// make sure IDs are the same across clients
function synced_createId(existingId) {
    if (existingId === void 0) { existingId = 0; }
    var obj = exports.get();
    // TODO: check for duplicate ids
    if (existingId) {
        if (existingId > obj.synced_idCounter) {
            obj.synced_idCounter = existingId;
            console.warn(namespace, 'existingId is greater than synced_idCounter');
        }
        return existingId;
    }
    obj.synced_idCounter++;
    return obj.synced_idCounter;
}
exports.synced_createId = synced_createId;
